import { __awaiter, __generator, __spreadArray, __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React, { forwardRef, useRef, useState, useEffect, useImperativeHandle } from 'react';
import { isFunction, isArray } from 'lodash';
import { PullToRefresh } from 'antd-mobile';
import classNames from 'classnames';
import transformDefaultResCfg from '../../utils/transformDefaultResCfg.js';
import Body from './Body.js';
import Bottom from './Bottom.js';
import './index.less.js';

function getIsNextPage(current, pageSize) {
  if (isArray(current)) {
    return current.length < pageSize ? false : true;
  }
  return false;
}
function TiList(props, ref) {
  var _this = this;
  var className = props.className,
    _a = props.immediate,
    immediate = _a === void 0 ? true : _a,
    _b = props.defaultPage,
    defaultPage = _b === void 0 ? 1 : _b,
    _c = props.defaultSize,
    defaultSize = _c === void 0 ? 20 : _c,
    _d = props.infinite,
    infinite = _d === void 0 ? true : _d,
    _e = props.pullToRefresh,
    pullToRefresh = _e === void 0 ? true : _e,
    _f = props.rowKey,
    rowKey = _f === void 0 ? 'id' : _f,
    _g = props.presetItemStyle,
    presetItemStyle = _g === void 0 ? 'split-line' : _g,
    _h = props.dataSource,
    dataSource = _h === void 0 ? [] : _h,
    _params = props.params,
    request = props.request,
    renderItem = props.renderItem,
    onItemClick = props.onItemClick,
    _j = props.transform,
    transform = _j === void 0 ? transformDefaultResCfg : _j;
  var hasMore = useRef(true);
  var _k = useState([]),
    fetchData = _k[0],
    setFetchData = _k[1];
  var _l = useState({
      page: defaultPage,
      size: defaultSize
    }),
    pageConfig = _l[0],
    setPageConfig = _l[1];
  var _m = useState('success'),
    status = _m[0],
    setStatus = _m[1];
  useEffect(function () {
    if (immediate && isFunction(request)) {
      onInit();
    }
  }, [_params]);
  // 加载初始化数据
  var onInit = function onInit() {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, handleRequest({
              page: defaultPage,
              size: defaultSize
            }, {
              isInit: true
            })];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  var onRefresh = function onRefresh() {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, handleRequest({
              page: defaultPage,
              size: defaultSize
            }, {
              isRefresh: true
            })];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  // 加载下一页数据
  var onLoadMore = function onLoadMore() {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, handleRequest({
              page: pageConfig.page + 1,
              size: pageConfig.size
            })];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  // 请求数据方法处理
  var handleRequest = function handleRequest(pageCfg, fetchConfig) {
    return __awaiter(_this, void 0, void 0, function () {
      var _a, _b, isInit, _c, isRefresh, params, response, _d, _success, _data;
      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            if (!isFunction(request) || !isFunction(transform)) {
              return [2 /*return*/];
            }
            _a = fetchConfig !== null && fetchConfig !== void 0 ? fetchConfig : {}, _b = _a.isInit, isInit = _b === void 0 ? false : _b, _c = _a.isRefresh, isRefresh = _c === void 0 ? false : _c;
            if (isInit) {
              setStatus('init-loading');
            }
            if (isRefresh) {
              setStatus('refresh-loading');
            }
            params = __assign({
              page: pageCfg.page,
              size: pageCfg.size
            }, _params || {});
            return [4 /*yield*/, request(params)];
          case 1:
            response = _e.sent();
            _d = transform(response), _success = _d.success, _data = _d.data;
            if (_success) {
              hasMore.current = getIsNextPage(_data, pageCfg.size);
              if (isInit || isRefresh) {
                setFetchData(_data);
              } else {
                setFetchData(function (state) {
                  return __spreadArray(__spreadArray([], state, true), _data, true);
                });
              }
              setPageConfig(function (state) {
                return __assign(__assign({}, state), params);
              });
              setStatus('success');
            } else {
              setStatus('error');
            }
            return [2 /*return*/];
        }
      });
    });
  };
  var data = isFunction(request) ? fetchData : dataSource;
  var isEmpty = data.length === 0;
  var isPullToRefresh = pullToRefresh && isFunction(request) && status === 'success';
  var isInfinite = infinite && isFunction(request) && !isEmpty && status === 'success';
  // 向父组件暴露search方法
  useImperativeHandle(ref, function () {
    return {
      onSearch: onInit
    };
  });
  var rootCls = classNames('ti-list', className);
  return /*#__PURE__*/React.createElement("div", {
    className: rootCls
  }, /*#__PURE__*/React.createElement(PullToRefresh, {
    onRefresh: onRefresh,
    disabled: !isPullToRefresh
  }, /*#__PURE__*/React.createElement(Body, {
    data: data,
    rowKey: rowKey,
    renderItem: renderItem,
    onReset: onInit,
    status: status,
    empty: isEmpty,
    presetItemStyle: presetItemStyle,
    onItemClick: onItemClick
  }), /*#__PURE__*/React.createElement(Bottom, {
    loadMore: onLoadMore,
    more: hasMore.current,
    infinite: isInfinite
  })));
}
var List = /*#__PURE__*/forwardRef(TiList);

export { List as default };
